import { render, staticRenderFns } from "./MainMiddlePanelForRectorat.vue?vue&type=template&id=356ce72c&scoped=true&"
import script from "./MainMiddlePanelForRectorat.vue?vue&type=script&lang=js&"
export * from "./MainMiddlePanelForRectorat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ce72c",
  null
  
)

export default component.exports